import { GripVertical, ChevronUp, ChevronDown } from 'lucide-react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { cn } from 'components/UI/cn'
import { SalesStage } from 'models/sales_stages'

export interface StageDragAndDropItemProps {
  id: number
  stage: SalesStage
  onMoveUp: () => void
  onMoveDown: () => void
  isFirst: boolean
  isLast: boolean
  disabled?: boolean
}

export function StageDragAndDropItem({
  id,
  stage,
  onMoveUp,
  onMoveDown,
  isFirst,
  isLast,
  disabled = false,
}: StageDragAndDropItemProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="px-3 my-1 rounded bg-sage-extra-lt"
    >
      <div className="justify-between items-center flex py-3">
        <div className="flex items-center gap-3">
          <div
            {...attributes}
            {...listeners}
            className={disabled ? 'opacity-30 cursor-not-allowed' : ''}
          >
            <GripVertical
              size={17}
              className={
                disabled
                  ? 'text-fg-subtle cursor-not-allowed'
                  : 'text-fg-subtle hover:cursor-move'
              }
            />
          </div>
          <div className="font-medium">{stage.stage}</div>
          {stage.win_rate !== null && (
            <div className="text-sm text-gray-500">
              ({stage.win_rate}% win rate)
            </div>
          )}
        </div>
        <div className="flex flex-row items-center gap-1">
          <div
            className={cn('rounded h-7 w-7 flex items-center justify-center', {
              invisible: isFirst,
              'cursor-pointer hover:bg-surface-hover': !disabled,
              'opacity-30 cursor-not-allowed': disabled,
            })}
            onClick={disabled ? undefined : onMoveUp}
          >
            <ChevronUp size={18} className="text-fg-subtle" />
          </div>
          <div
            className={cn('rounded h-7 w-7 flex items-center justify-center', {
              invisible: isLast,
              'cursor-pointer hover:bg-surface-hover': !disabled,
              'opacity-30 cursor-not-allowed': disabled,
            })}
            onClick={disabled ? undefined : onMoveDown}
          >
            <ChevronDown size={18} className="text-fg-subtle" />
          </div>
        </div>
      </div>
    </div>
  )
}
